import React from "react";
const SvgHpArrow = props => (
  <svg viewBox="0 0 12 7" {...props}>
    <path
      fill="#1A1F24"
      d="M.183.183A.625.625 0 01.98.111l.087.072 4.558 4.559L10.183.183a.625.625 0 01.797-.072l.087.072a.625.625 0 01.072.797l-.072.087-5 5a.625.625 0 01-.797.072l-.087-.072-5-5a.625.625 0 010-.884z"
    />
  </svg>
);
export default SvgHpArrow;
